import { BackSide, Color, UniformsUtils, UniformsLib, CustomBlending, SrcAlphaFactor, OneMinusSrcAlphaFactor, ShaderMaterial, Uniform } from "three";
import { registerCustomShaderChunk } from "./shader.utils";
import { renderer } from "../RendererGlobals";
const CUSTOM_LIGHTS_PHONG_PARS_FRAGMENT = require("./custom.lights.phong.pars.fragment.glsl");
const CUSTOM_SHADOWMAP_PARS_FRAGMENT = require("./custom.shadowmap.pars.fragment.glsl");
const CUSTOM_SHADOWMAP_FRAGMENT = require("./custom.shadowmap.fragment.glsl");
registerCustomShaderChunk("custom_lights_phong_pars_fragment", CUSTOM_LIGHTS_PHONG_PARS_FRAGMENT);
registerCustomShaderChunk("custom_shadowmap_pars_fragment", CUSTOM_SHADOWMAP_PARS_FRAGMENT);
registerCustomShaderChunk("custom_shadowmap_fragment", CUSTOM_SHADOWMAP_FRAGMENT);
const INFINITE_PLANE_VERTEX_SHADER = require("./infinite.plane.vert");
const INFINITE_PLANE_FRAGMENT_SHADER = require("./infinite.plane.frag");
export const INFINITE_PLANE_MATERIAL = new ShaderMaterial({
    defines: {
        USE_SHADOWMAP: "",
        SHADOWMAP_TYPE_PCF_SOFT: ""
    },
    uniforms: UniformsUtils.merge([
        /* we need at least some of these to use threes fragments and not get undefined errors */
        UniformsLib.common,
        UniformsLib.lights,
        {
            uColor: new Uniform(new Color(0xffffff)),
            uFogColor: new Uniform(new Color(0xffffff)),
            uTexture: new Uniform(null),
            uUseTexture: new Uniform(0),
            // common parameters for phong based lighting
            specular: new Uniform(new Color(0x080808)),
            shininess: new Uniform(256),
            uPlainElevation: new Uniform(0.0)
        }
    ]),
    vertexShader: INFINITE_PLANE_VERTEX_SHADER,
    fragmentShader: INFINITE_PLANE_FRAGMENT_SHADER,
    side: BackSide,
    depthWrite: renderer.capabilities.isWebGL2,
    depthTest: renderer.capabilities.isWebGL2,
    lights: true,
    blending: CustomBlending,
    blendSrc: SrcAlphaFactor,
    blendDst: OneMinusSrcAlphaFactor,
    // setting transparent to true messes up the render order
    transparent: false,
    toneMapped: false
});
INFINITE_PLANE_MATERIAL.type += " INFINITE_PLANE_MATERIAL";
if (renderer.capabilities.isWebGL2) {
    INFINITE_PLANE_MATERIAL.defines.WRITE_DEPTH = "";
}
